export default __webpack_public_path__ + "static/media/Grips of the Haunter in the Dark.4d2bdfa3.jpg";